export { MailCheck as default } from './MailCheck';
